import config from "../config";

const buildAbsoluteUrl = (baseUrl, path) => {
  const normalizedBaseUrl = baseUrl.endsWith("/")
    ? baseUrl.slice(0, -1)
    : baseUrl;

  return `${normalizedBaseUrl}${path}`;
};

export const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  if (process.env.NODE_ENV === "development") {
    return `http://${config.host}:3001`;
  }

  return `https://${config.idpHost}`;
};

export const getIdpBaseUrl = () => {
  if (process.env.REACT_APP_IDP_BASE_URL) {
    return process.env.REACT_APP_IDP_BASE_URL;
  }

  if (process.env.NODE_ENV === "development") {
    return `http://${config.host}:4000`;
  }

  return `https://${config.idpHost}/idp`;
};

export const buildApiUrl = (path) => buildAbsoluteUrl(getApiBaseUrl(), path);
export const buildIdpUrl = (path) => buildAbsoluteUrl(getIdpBaseUrl(), path);
